import { request } from '@/shared/api';
export function fetchTasks(status = 'OPEN') {
    return request(`/api/v1/tasks?status=${status}&limit=100`);
}
export function fetchTask(taskId) {
    return request(`/api/v1/tasks/${taskId}`);
}
export function startTask(taskId, version) {
    return request(`/api/v1/tasks/${taskId}/start`, {
        method: 'POST',
        body: JSON.stringify({ version }),
    });
}
export function completeTask(taskId, version, comment) {
    return request(`/api/v1/tasks/${taskId}/complete`, {
        method: 'POST',
        body: JSON.stringify({ version, comment }),
    });
}
